// src/pages/LanguageEdit.jsx
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { FiSave, FiTrash2, FiUpload } from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useDropzone } from "react-dropzone";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const LanguageEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // Dil Bilgisi
  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  // Bayrak için
  const [flag, setFlag] = useState(null);             // Yeni seçilen bayrak 
  const [currentFlag, setCurrentFlag] = useState("");   // Mevcut bayrak URL 
  const [previewFlag, setPreviewFlag] = useState("");   // Gösterilecek önizleme 
  const [flagRemoved, setFlagRemoved] = useState(false);  

  // Logo için
  const [logo, setLogo] = useState(null);
  const [currentLogo, setCurrentLogo] = useState("");
  const [previewLogo, setPreviewLogo] = useState("");
  const [logoRemoved, setLogoRemoved] = useState(false);

  // Çeviriler
  const [langTranslations, setlangTranslations] = useState({});

  // Yüklenme & Kaydetme Durumu
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Sayfa açılır açılmaz dil ve çeviri verilerini çek
  useEffect(() => {
    fetchLanguageData();
  }, []);

  const fetchLanguageData = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCode(resp.data.language.code);
      setName(resp.data.language.name);
      setCurrentFlag(resp.data.language.flag || "");
      setCurrentLogo(resp.data.language.logo || "");

      // Mevcut bayrak ve logo varsa önizlemeye ekle
      if (resp.data.language.flag) {
        setPreviewFlag(`http://localhost:4000${resp.data.language.flag}`);
      }
      if (resp.data.language.logo) {
        setPreviewLogo(`http://localhost:4000${resp.data.language.logo}`);
      }
    } catch (error) {
      console.error("❌ Dil verisi alınamadı:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (flag) {
      const objectUrl = URL.createObjectURL(flag);
      console.log("🟢 Yeni bayrak önizleme URL oluşturuldu:", objectUrl);
  
      setPreviewFlag(objectUrl);
  
      return () => {
        console.log("🗑️ Önizleme URL temizlendi (BAYRAK):", objectUrl);
        URL.revokeObjectURL(objectUrl); // Önceki `blob:` URL'leri temizle
      };
    }
  }, [flag]);

useEffect(() => {
  if (logo) {
    const objectUrl = URL.createObjectURL(logo);
    console.log("🟢 Yeni logo önizleme URL oluşturuldu:", objectUrl);

    setPreviewLogo(objectUrl);

    return () => {
      console.log("🗑️ Önizleme URL temizlendi:", objectUrl);
      URL.revokeObjectURL(objectUrl); // Önceki `blob:` URL'leri temizle
    };
  }
}, [logo]);

useEffect(() => {
  console.log("Yeni flag seçildi:", flag);
  console.log("Yeni flag önizleme URL:", previewFlag);
}, [flag, previewFlag]);

useEffect(() => {
  console.log("Yeni logo seçildi:", logo);
  console.log("Yeni logo önizleme URL:", previewLogo);
}, [logo, previewLogo]);


  // Çeviri inputları için handler
  const handleValueChange = (keyName, newVal) => {
    setlangTranslations(prev => ({
      ...prev,
      [keyName]: { ...prev[keyName], value: newVal }
    }));
  };
  


  // DROPZONE - BAYRAK ALANI

  const onFlagDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setFlag(file);
  
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setPreviewFlag(reader.result); 
        console.log("Yeni bayrak önizleme (base64):", reader.result);
      };
    }
  }, []);

  const { getRootProps: getFlagRootProps, getInputProps: getFlagInputProps, isDragActive: isFlagDragActive } = useDropzone({
    onDrop: onFlagDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  const handleRemoveFlag = () => {
    setPreviewFlag(""); // Önizlemeyi temizle
    setFlag(null);      // Seçilen bayrağı temizle
    setFlagRemoved(true);
    setCurrentFlag("");
  };


  // DROPZONE - LOGO ALANI
  
  const onLogoDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setLogo(file);
  
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setPreviewLogo(reader.result); 
        console.log("Yeni logo önizleme (base64):", reader.result);
      };
    }
  }, []);
  

  const { getRootProps: getLogoRootProps, getInputProps: getLogoInputProps, isDragActive: isLogoDragActive } = useDropzone({
    onDrop: onLogoDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  const handleRemoveLogo = () => {
    setPreviewLogo("");
    setLogo(null);
    setLogoRemoved(true);
    setCurrentLogo("");
  };

  
  // FORM GÖNDERME
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem("admin_token");
      let updatedFlag = currentFlag;
      let updatedLogo = currentLogo;

      //  Bayrak: silme veya güncelleme
      if (flagRemoved) {
        updatedFlag = ""; // Bayrak kaldırıldıysa boş yap
      } else if (flag) {
        const formData = new FormData();
        formData.append("flag", flag);
        const flagResp = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}/uploadFlag`,
          formData,
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
        );
        updatedFlag = flagResp.data.flagUrl;
      }

      // Logo: silme veya güncelleme
      if (logoRemoved) {
        updatedLogo = ""; // Logo kaldırıldıysa boş yap
      } else if (logo) {
        const formData = new FormData();
        formData.append("logo", logo);
        const logoResp = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}/uploadLogo`,
          formData,
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
        );
        updatedLogo = logoResp.data.logoUrl;
      }

      // Dil bilgilerini güncelle
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}`,
        {
          code,
          name,
          flag: updatedFlag,
          logo: updatedLogo,
         
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(" Dil bilgileri başarıyla güncellendi!", {
        position: "top-right",
        autoClose: 3000,
      });

      // navigate("/admin/language");
    } catch (error) {
      console.error("❌ Güncelleme hatası:", error);
      alert("Dil bilgileri güncellenemedi!");
    }
    setSaving(false);
  };


  if (loading) return <p>⏳ Yükleniyor...</p>;

  // Stil Ayarları
  const dropzoneBaseStyle = {
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  };

  // Bayrak için: Dosya yüklenmediğinde mavi, noktalı; yüklendiğinde düz, gri
  const flagDropzoneStyle = {
    ...dropzoneBaseStyle,
    ...(isFlagDragActive && !previewFlag
      ? { border: "2px dashed #28a745", backgroundColor: "#e6ffed" }
      : previewFlag
      ? { border: "2px solid #ccc", textAlign: "left" }
      : { border: "2px dashed #007bff", textAlign: "center" }),
  };

  // Logo için: Dosya yüklenmediğinde mavi, noktalı; yüklendiğinde düz, gri
  const logoDropzoneStyle = {
    ...dropzoneBaseStyle,
    ...(isLogoDragActive && !previewLogo
      ? { border: "2px dashed #28a745", backgroundColor: "#e6ffed" }
      : previewLogo
      ? { border: "2px solid #ccc", textAlign: "left" }
      : { border: "2px dashed #007bff", textAlign: "center" }),
  };

  // Bayrak önizleme stili
  const flagPreviewStyle = {
    width: "40px",
    height: "25px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    objectFit: "contain",
  };

  // Logo önizleme stili: 280x80
  const logoPreviewStyle = {
    width: "280px",
    height: "80px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    objectFit: "contain",
  };

  return (
    <div className="container mt-4">
       <ToastContainer />
      <form onSubmit={handleSubmit} className="card p-4">
        {/* Dil Bilgisi */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("TABLE_LANGUAGE_CODE_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            placeholder={getText("LANGUAGE_CODE_PLACEHOLDER")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("TABLE_LANGUAGE_NAME_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            placeholder={getText("LANGUAGE_NAME_PLACEHOLDER")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        {/* Bayrak Alanı - Dropzone Kullanımı */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LANGUAGE_FLAG")}</label>
          <div {...getFlagRootProps()} style={flagDropzoneStyle}>
            <input {...getFlagInputProps()} />
            {!previewFlag ? (
              <div className="d-flex flex-column align-items-center">
                <FiUpload size={32} className="text-primary" />
                <p className="mt-2 mb-0">{getText("UPLOAD_FLAG")}</p>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-start">
                <img
                  
                  src={
                    previewFlag.startsWith("data") || previewFlag.startsWith("http")
                      ? previewFlag
                      : `${process.env.REACT_APP_API_BASE_URL}${previewFlag}`
                  }
                  alt="Bayrak Önizleme"
                  style={flagPreviewStyle}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger mt-2"
                  onClick={handleRemoveFlag}
                >
                  <FiTrash2 className="me-1" /> {getText("DELETE_FILE")}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Logo Alanı - Dropzone Kullanımı */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LANGUAGE_LOGO")}</label>
          <div {...getLogoRootProps()} style={logoDropzoneStyle}>
          <input {...getLogoInputProps()} />
          {!previewLogo ? (
            <div className="d-flex flex-column align-items-center">
              <FiUpload size={32} className="text-primary" />
              <p className="mt-2 mb-0">{getText("UPLOAD_LOGO")}</p>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-start">
              <img
                src={
                  previewLogo.startsWith("data") || previewLogo.startsWith("http")
                    ? previewLogo
                    : `${process.env.REACT_APP_API_BASE_URL}${previewLogo}`
                }
                alt="Logo Önizleme"
                style={logoPreviewStyle}
              />
              <button
                type="button"
                className="btn btn-sm btn-outline-danger mt-2"
                onClick={handleRemoveLogo}
              >
                <FiTrash2 className="me-1" /> {getText("DELETE_FILE")}
              </button>
            </div>
          )}
        </div>
        </div>

        <div className="d-flex justify-content-center mt-4">
          <button className="btn btn-primary d-flex align-items-center shadow-sm px-4 py-2" type="submit" disabled={saving}>
            <FiSave className="me-2" />
            {saving ? getText("SAVING_BTN") : getText("SAVE_BTN")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LanguageEdit;
